import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { getFieldErrors } from "../helpers";
import { tryConfirmLogin } from "./authReducer";

export interface IGeneralStats {
    members: {
        total: number;
        unverified: number;
        verified: number;
    },
    tutors: {
        total: number;
        unverified: number;
        verified: number;
    },
    courses: {
        total: number
    },
    articles: {
        total: number
    },
    recordedWorkshops: {
        total: number
    },
    events: {
        total: number
    },
}

export interface IStatsState {
    fetchingStats: boolean;
    stats: IGeneralStats | null;
    fetchStatsErr: string | null;
}

const initialState = {
    fetchingStats: false,
    stats: null,
    fetchStatsErr: null
} as IStatsState;

const statsSlice = createSlice({
    name: 'stats',
    initialState,
    reducers: {
        clearFetchStatsErr: (state: IStatsState) => {
            state.fetchStatsErr = null;
        },
        fetchStatsStart: (state: IStatsState) => {
            state.fetchingStats = true;
            state.fetchStatsErr = null;
        },
        fetchStatsPass: (state: IStatsState, action: PayloadAction<IGeneralStats>) => {
            state.fetchingStats = false;
            state.stats = action.payload;
        },
        fetchStatsFail: (state: IStatsState, action: PayloadAction<string>) => {
            state.fetchingStats = false;
            state.fetchStatsErr = action.payload;
        }
    },
});

export const {
    clearFetchStatsErr,
    fetchStatsStart,
    fetchStatsPass,
    fetchStatsFail
} = statsSlice.actions;

interface ITryFetchStatsArg {
    authToken: string;
}

export const tryFetchStats = createAsyncThunk('stats/tryFetchStats', (arg: ITryFetchStatsArg, { dispatch }) => {

    const { authToken } = arg;

    const endpoint = `${process.env.REACT_APP_SERVER_ENDPOINT}/api/general-stats`;

    dispatch(fetchStatsStart());

    axios.get(endpoint, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
        }
    }).then(res => {
        dispatch(fetchStatsPass(res.data));
    }).catch(err => {
        const data = err?.response?.data;

        if (data?.err && (data.err === "Session expired")) {
            dispatch(tryConfirmLogin({ authToken }));
            return;
        }

        if (data?.errors) {
            dispatch(fetchStatsFail(getFieldErrors(data.errors)[0].msg))
        } else if (data?.err) {
            dispatch(fetchStatsFail(data.err));
        } else {
            dispatch(fetchStatsFail('Check your network connection.'));
        }
    });

});


export default statsSlice.reducer;